import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ChatThread } from "@services/chatHistory";

export interface ChatHistorySidebarProps {
  threads: ChatThread[];
  activeThreadId: string | null;
  hasMoreThreads: boolean;
  isFetchingNextThreads: boolean;
  onNewConversation: () => void;
  onSelectThread: (threadId: string) => void;
  onLoadMoreThreads: () => void;
  onScroll?: (event: React.UIEvent<HTMLUListElement, UIEvent>) => void;
}

export const ChatHistorySidebar = ({
  threads,
  activeThreadId,
  hasMoreThreads,
  isFetchingNextThreads,
  onNewConversation,
  onSelectThread,
  onLoadMoreThreads,
  onScroll
}: ChatHistorySidebarProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid #e1e1e1",
        pr: 1
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1
        }}
      >
        <Typography variant="h6">
          {t("chatbot.history.title", "Historial de chat")}
        </Typography>
        <Button variant="contained" size="small" onClick={onNewConversation}>
          {t("common.create")}
        </Button>
      </Box>
      <List
        sx={{ flex: 1, overflowY: "auto" }}
        onScroll={onScroll}
      >
        {threads.map((thread) => (
          <ListItemButton
            key={thread.id}
            selected={thread.id === activeThreadId}
            onClick={() => onSelectThread(thread.id)}
          >
            <ListItemText
              primary={
                thread.title || t("chatbot.history.title", "Conversación")
              }
              secondary={new Date(thread.updatedAt).toLocaleString()}
            />
          </ListItemButton>
        ))}
        {hasMoreThreads && (
          <ListItemButton
            onClick={onLoadMoreThreads}
            disabled={isFetchingNextThreads}
          >
            <ListItemText
              secondary={
                isFetchingNextThreads
                  ? t("chatbot.common.loading", "Cargando...")
                  : t("common.continue")
              }
            />
          </ListItemButton>
        )}
      </List>
    </Box>
  );
};

export default ChatHistorySidebar;

